import { render, staticRenderFns } from "./GoodsTypeAdd.vue?vue&type=template&id=701c97cf&scoped=true&"
import script from "./GoodsTypeAdd.vue?vue&type=script&lang=js&"
export * from "./GoodsTypeAdd.vue?vue&type=script&lang=js&"
import style0 from "./GoodsTypeAdd.vue?vue&type=style&index=0&id=701c97cf&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "701c97cf",
  null
  
)

export default component.exports